<template>
  <div>
    <b-alert :variant="variant" class="py-2 text-center" show>
      <b-spinner :variant="variant" label="Spinning"></b-spinner>
      <br />
      <span
        class="ops-text font-weight-bolder"
        v-text="message"
        v-if="message"
      ></span>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "Saving...",
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
};
</script>

<style scoped>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(213, 211, 211, 0.5);
  z-index: 2;
}
#text {
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>
